<span [ngClass]="{'disabled': isDisabled, 'dropdown cursor-pointer':!isDisabled }" ng data-toggle="dropdown"><span class="navbar-toggler-icon"></span>
<div class="dropdown-menu">
    <div class="bg-light">
        <div class="list-group list-group-flush">
            <span>In quick link</span>
            <app-menu-render [isExpand]="true" [menu]="menu"></app-menu-render>
        </div>
    </div>
</div>
</span>